import { Form1008Data } from '../types'

export function pmt(
  principal: number,
  annualRatePct: number,
  months: number,
): number {
  if (!principal || !months) return 0
  const r = annualRatePct / 100 / 12
  if (r === 0) return principal / months
  const f = Math.pow(1 + r, months)
  return (principal * (r * f)) / (f - 1)
}

export function calculateMetrics(data: Form1008Data) {
  const firstMortgagePI = pmt(
    data.loanAmount,
    data.qualRate || data.noteRate,
    data.loanTermMonths,
  )

  const totalIncome =
    (data.income1 || 0) +
    (data.income2 || 0) +
    (data.income3 || 0) +
    (data.income4 || 0) +
    (data.incomeOther || 0) +
    (data.rentalIncomeSubject || 0) +
    (data.netRentalOther || 0)

  const totalHousing =
    firstMortgagePI +
    (data.subordinatePI || 0) +
    (data.homeownersInsurance || 0) +
    (data.supplementalInsurance || 0) +
    (data.propertyTaxes || 0) +
    (data.mortgageInsurance || 0) +
    (data.hoaDues || 0) +
    (data.otherHousing || 0)

  const minVal = Math.min(data.salesPrice || 0, data.appraisedValue || 0)

  const ltv = minVal > 0 ? (data.loanAmount / minVal) * 100 : 0
  const cltv =
    minVal > 0
      ? ((data.loanAmount + (data.subordinateAmount || 0)) / minVal) * 100
      : 0
  const hcltv = cltv

  const housingRatio = totalIncome > 0 ? (totalHousing / totalIncome) * 100 : 0
  const dti =
    totalIncome > 0
      ? ((totalHousing + (data.allOtherPayments || 0)) / totalIncome) * 100
      : 0

  const dscr =
    totalHousing > 0 ? (data.rentalIncomeSubject || 0) / totalHousing : 0

  return {
    firstMortgagePI,
    totalIncome,
    totalHousing,
    ltv,
    cltv,
    hcltv,
    housingRatio,
    dti,
    dscr,
  }
}
